import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
const products = [{
  title: "Aceite Temprano - 500 ml",
  description: "El aceite de oliva «Temprano», elaborado a partir de aceitunas de cosecha temprana, se caracteriza por su sabor intenso y vibrante, y por su alto contenido en polifenoles. Presenta un color verde intenso y un aroma fresco y herbáceo. Al elaborarse con aceitunas recogidas en su punto máximo de antioxidantes, es altamente nutritivo y ofrece una excelente estabilidad.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/02/openart-02177153620240936582de0ab192f8b1710090b8a2fff5cc9d767_0_1771536230718_074bbbc4.png?v=pyl4pfn78qs",
  url: "/OurOilPage"
}, {
  title: "Aceite Picudo - 500 ml",
  description: "El aceite de oliva «Picudo» es un aceite de oliva virgen extra español de alta calidad, valorado por su sabor rico y complejo y su intensa aromaticidad. Presenta un perfil afrutado característico, con notas de manzana madura, almendra verde y sutiles toques de frutas tropicales.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/02/openart-021771537057958e0570d30189b68d5608c0b11774ff85b25b54b_0_1771537084983_a09d0d3f-1.png?v=eeg3ogi9xbd",
  url: "/OurOilPage"
}, {
  title: "Aceite Hojiblanca - 500 ml",
  description: "El aceite de oliva «Hojiblanca» es una variedad premium de aceite de oliva virgen extra español, conocida por su perfil de sabor equilibrado, que combina notas dulces, amargas y picantes. Presenta un aroma afrutado con matices de hierba recién cortada, almendra verde y un sutil toque de alcachofa.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/02/openart-02177153796403237f55b1d824c1f00b978e13a494fe3783c3602_0_1771537994968_36bb04f9.png?v=75i6u4r5rnd",
  url: "/OurOilPage"
}, {
  title: "Formato familiar – 2 litros",
  description: "Disponible en: Temprano · Picudo · Hojiblanca · Multi-varietal \xA0\n\n\xA0Formato práctico y económico para el uso diario, manteniendo la calidad de nuestro aceite de oliva virgen extra.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/02/openart-02177153829331232716c93dca5f9defc0d360fd0d690bd31c3d9_0_1771538325815_481bbcc1.png?v=4hd56l8jfhg",
  url: "/OurOilPage"
}, {
  title: "Aceite\xA0Multi-Varietal - 5 litros",
  description: "Elaborado a partir de una mezcla de diferentes variedades de aceituna, ofrece un perfil de sabor complejo y bien equilibrado.\nEs un aceite altamente versátil, ideal tanto para usos en crudo —como aliñar ensaladas o acompañar pan— como para realzar platos cocinados.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/02/openart-021771538691810c2670fe791a5f29d61bdea8e0ada6c5dba2266_0_1771538713530_370c5127.png?v=4ydjdoxmurj",
  url: "/OurOilPage"
}, {
  title: "Gel 200 ml - 100 ml",
  description: "Descubre nuestro exclusivo gel de aceite de oliva virgen extra, ideal para convertir tus tostadas en una experiencia gourmet. Con una textura suave y untuosa, conserva todo el sabor y los aromas del mejor AOVE.\n\n\nPerfecto para quienes buscan un toque innovador sin renunciar a la tradición. Su aplicación es limpia y precisa, sin goteos ni excesos.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/02/openart-021771538955814378c141953f92ec627da9d675fe03be0d28f5e_0_1771538977163_2c411199-1.png?v=e0k0oxi6cwh",
  url: "/OurOilPage"
}, {
  title: "Picudo/ Hojiblanca\xA0 Lata 2,5 L",
  description: "Disponible en formato de lata de 2,5 litros, una opción práctica para quienes utilizan aceite de oliva virgen extra con frecuencia en la cocina. El envase protege el aceite de la luz y ayuda a conservar mejor sus aromas y cualidades naturales.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/03/openart-image_1773239909175_45b2ee32_1773239909236_913fb258.png?v=cxj282m19n",
  url: "/OurOilPage"
}, {
  title: "Picudo/ Hojiblanca Lata 1L",
  description: "El formato de 1 litro ofrece el equilibrio perfecto entre comodidad y conservación. La lata protege el aceite de la luz, preservando su frescura, aroma y calidad.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/03/openart-image_1773239300996_a04dc83c_1773239301676_88a13ce0.png?v=bt4ydl1j3e7",
  url: "/OurOilPage"
}, {
  title: "Picudo/ Hojiblanca Lata 0,5 L",
  description: "Un formato compacto y práctico de aceite de oliva virgen extra, ideal para el uso diario. La lata protege el aceite de la luz y ayuda a conservar mejor sus aromas y cualidades naturales.",
  image: "https://wise-hagfish.10web.cloud/wp-content/uploads/2026/03/openart-image_1773241006514_5a957cc7_1773241006646_61e09d56.png?v=c5n0wkn8k9s",
  url: "/OurOilPage"
}];
export default function OurCollectionProductGrid() {
  return <section id="nuestra-colección-product-grid" className="bg-background section ![padding:60px_0px_80px_0px]">
      <div className="container">
        
        <div className="mb-8 text-center">
          <h2 className="text-primary mb-4">Nuestra Colección</h2>
          <div className="h-1 w-24 bg-primary/30 mx-auto rounded-full" />
        </div>

        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {products.map((product, i) => <Link key={i} to={product.url} className="group block h-full" data-index={i}>
              <Card className="h-full border-none shadow-none bg-transparent hover:bg-white/50 transition-colors duration-300 rounded-xl overflow-hidden">
                <CardHeader className="p-0">
                  <div className="aspect-[4/5] w-full overflow-hidden rounded-xl bg-secondary-200 relative">
                    <img src={product.image} alt={product.title} className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
                  </div>
                </CardHeader>
                <CardContent className="pt-6 px-2 text-center">
                  <CardTitle className="text-2xl font-serif text-primary mb-3 group-hover:text-primary-700 transition-colors">
                    {product.title}
                  </CardTitle>
                  <CardDescription className="text-foreground/80 font-sans text-base leading-relaxed">
                    {product.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </Link>)}
        </div>

        
        <div className="mt-20 text-center max-w-3xl mx-auto">
          <p className="text-muted-foreground italic text-lg border-t border-primary/20 pt-8">Todos nuestros aceites de oliva se cosechan en temporada y proceden de una única finca, lo que garantiza frescura, trazabilidad y un sabor excepcional en cada botella.</p>
        </div>
      </div>
    </section>;
}